import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './containers/auth/login';
import Signup from './containers/auth/signup';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { SuperAdminRoutes } from './routes/allRoutes';
import AppProvider from './context';
import ForgotPassword from './containers/auth/forgotPassword';
import firebase from 'firebase';
import { ProtectedLayout } from './components/protectedLayout';
import TripDetail from './containers/app/superAdminScreens/trips/tripDetail';
import PrivacyPolicy from './containers/auth/privacyPolicy/index';
import ContactSupport from './containers/auth/contactSupport/index';

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: [
        'Lato',
        'sans-serif',
        // '"Apple Color Emoji"',
        // '"Segoe UI Emoji"',
        // '"Segoe UI Symbol"',
      ].join(','),
    },
    button: {
      fontFamily: ['Lato', 'sans-serif'].join(','),
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <AppProvider>
        <Routes>
          <Route path='/login' element={<Login />} />
          {/* <Route path='/signup' element={<Signup />} /> */}
          <Route path='/PrivacyPolicy' element={<PrivacyPolicy />} />
          <Route path='/forgotPassword' element={<ForgotPassword />} />
          <Route path='/contactSupport' element={<ContactSupport />} />
          <Route path='/' element={<ProtectedLayout />}>
            {SuperAdminRoutes.map(
              ({ component: Component, path, exact, id }) => {
                return (
                  <Route
                    key={id}
                    path={path}
                    exact={exact}
                    element={Component}
                  />
                );
              }
            )}
            <Route path='/matchDetail/:id' element={<TripDetail />} />
          </Route>
        </Routes>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;
